module.exports = __webpack_public_path__ + "videos/video-1025.c719a4f.webm";